module.exports = __webpack_public_path__ + "img/T1D_xh9.1aee291e.png";